export const PoemAntiInfantry = () => {
    return (
        <div id="022" className="">
            <p>big heart,</p>
            <p>fast forward present, </p>
            <p>is the train here yet?</p>
            <p>strangers turn into familiar strangers,</p>
            <p>a mouthful of plastic,</p>
            <p>something in my throat?</p>
            <br />
            <p>big heart,</p>
            <p>shrapnel grenade heart,</p>
            <p>so many things in it,</p>
            <p>like it's gonna burst at the seams or crush the other organs.</p>
            <p>uphold the present,</p>
            <p>my father's tears</p>
            <p>(mostly subdued, but definitely present),</p>
            <p>my mother's worries</p>
            <p>(i fear they might one day asphyxiate her),</p>
            <br />
            <p>no hearts without circuits, no chests without wiring,</p>
            <p>if only there was any way to take</p>
            <p>everyone's problems upon myself instead.</p>
            <p>the planet spins</p>
            <p>faster and faster,</p>
            <p>i watch you slowly start to drift away,</p>
            <p>and only if i could do anything</p>
            <p>to stop the spinning.</p>
        </div>
    );
};
